import React from "react";
import styled from "styled-components";
import { HorizontalProgressBar } from "source/app/presentation/MainPanel/KeyValueLogs/PercentValue/HorizontalProgressBarr";
import { ShowRecentEmotionsPercentValue } from "source/app/presentation/MainPanel/KeyValueLogs/PercentValue/ShowRecentEmotionsPercentValue";
import { GetEmotionValuePercentColor } from "source/app/presentation/MainPanel/KeyValueLogs/KeyValueLogs";
import { IKeyValueLogsState } from "../IKeyValueLogsState";

export const EmotionProgressBarContainer = ({
    state,
}: {
    state: IKeyValueLogsState;
}) => {
    if (state.percentValue === null || state.percentValue === 0) {
        return null;
    }

    const textColor = GetEmotionValuePercentColor(state.percentValue);

    return (
        <StyledEmotionProgressBarContainer>
            <HorizontalProgressBar value={state.percentValue} />
            <StyledNumberOnProgressBar color={textColor}>
                <ShowRecentEmotionsPercentValue state={state} />
            </StyledNumberOnProgressBar>
        </StyledEmotionProgressBarContainer>
    );
};

const StyledEmotionProgressBarContainer = styled.div`
    position: relative;
    display: inline-block;
    text-align: center;
`;

const StyledNumberOnProgressBar = styled.span<{ color: string }>`
    color: ${(props) => props.color};
    display: block;
    left: 50%;
    position: absolute;
    top: calc(50% + 1px);
    transform: translate(-50%, -50%);
    transition: filter 180ms ease;
    z-index: 2;

    &:hover {
        filter: brightness(1.2);
    }
`;
